import {
  normalizePlatformIconName,
  resolveSwingIconUrl,
} from '@/common/utils/resolvePlatformIcon'

const IMG_TAG_REGEX = /<img\b([^>]*?)>/gi
const IMG_SRC_ATTR_REGEX = /\bsrc\s*=\s*["']([^"']+)["']/i

/** Swing `/res/icons/foo.png` → bundled swingicons URL; external URLs unchanged. */
export function normalizeHtmlImageSrc(rawSrc: string): string {
  const trimmed = String(rawSrc ?? '').trim()
  if (!trimmed) return trimmed
  if (/^(?:https?:|data:|mailto:|tel:)/i.test(trimmed)) {
    return trimmed
  }

  let iconName = trimmed.replace(/^\/+/, '')
  if (iconName.toLowerCase().startsWith('res/icons/')) {
    iconName = iconName.slice('res/icons/'.length)
  }

  const resolved = resolveSwingIconUrl(normalizePlatformIconName(iconName))
  return resolved ?? trimmed
}

export function rewriteHtmlImageSrc(html: string): string {
  if (!html || typeof html !== 'string') return html

  return html.replace(IMG_TAG_REGEX, (tag, attrs: string) => {
    const srcMatch = attrs.match(IMG_SRC_ATTR_REGEX)
    if (!srcMatch) return tag

    const resolved = normalizeHtmlImageSrc(srcMatch[1])
    if (resolved === srcMatch[1]) return tag

    const nextAttrs = attrs.replace(IMG_SRC_ATTR_REGEX, `src="${resolved}"`)
    return `<img${nextAttrs}>`
  })
}
